import { elementController } from '@public-pages/runtime-core';

elementController('contact-channels', ({ query, emit }) => {
  const modalButton = query('#modal-button');

  function openContactFormModal() {
    emit('document:openContactModal');
  }

  modalButton?.addEventListener('click', openContactFormModal);
});
